import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import {
  Image,
  View,
  useWindowDimensions,
  ScrollView,
  ImageBackground,
} from 'react-native';
import { Notices } from './components/Notices';
import { Text } from '../../components/Text';
import { Footer } from '../../components/Footer';
import { useIsDesktop } from '../../hooks/useIsDeskTop';
import { StyleSheet } from 'react-native';
import { COLORS, FONTS } from '../../constants';
import { CorporateEvent } from './components/CorporateEvent';
import { Activities } from './components/Activities';
import { User } from './components/User';
import { BookACamp } from './components/BookACamp';
import { IS_WEB, MAX_WIDTH } from '../../constants/platform';
import { useSelector } from 'react-redux';
import { RootState } from '../../services/redux';
import Swiper from 'react-native-web-swiper';
import HomeApi from '../../services/api/home.api';
import { ISlider } from '../../types/home.types';
import { useRole } from '../../hooks/useRole';
import { BookActivities } from './components/BookActivities';
import LinearGradient from 'react-native-linear-gradient';

const Home: FC = () => {
  const { user, loggedin, fcmToken } = useSelector(
    (state: RootState) => state?.authReducer
  );
  const { isVolunteerIntructor, isIndividualCorporate } = useRole();
  const { width: screenWidth } = useWindowDimensions();
  const isDesktop = useIsDesktop();
  const [sliders, setSliders] = useState<ISlider[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const styles = StyleSheet.create({
    container: {
      flex: 1,
      height: '100%',
      width: '76%',
      resizeMode: 'cover',
      justifyContent: 'flex-start',
    },
    backgroundImage: {
      width: isDesktop() ? undefined : screenWidth,
      height: (isDesktop() ? 550 : screenWidth) * (1346 / 1796),
    },
  });

  const getSlider = useCallback(async () => {
    setIsLoading(true);
    HomeApi.getSliders(1)
      .then((res) => {
        setSliders(res.data.data.items);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const renderSwiper = useMemo(() => {
    if (isLoading === false && sliders && sliders.length > 0) {
      return (
        <Swiper
          controlsProps={{
            prevPos: false,
            nextPos: false,
            DotComponent: () => <></>,
          }}
          timeout={5}
          loop
        >
          {sliders.map((item) => (
            <View key={item.id} style={{ flex: 1, position: 'relative' }}>
              <Image
                source={{ uri: item.image_url ? item.image_url : '' }}
                style={{
                  width: '100%',
                  height: 200,
                }}
              />
              <Text
                style={{
                  textTransform: 'uppercase',
                  fontFamily: FONTS.AvenirMedium,
                  fontSize: 20,
                  letterSpacing: 1,
                  color: item.color_options.title_color
                    ? item.color_options.title_color
                    : COLORS.BLACK,
                  textAlign: 'center',
                  fontWeight: '700',
                  position: 'absolute',
                  left: 0,
                  right: 0,
                  top: 40,
                }}
              >
                {item.title}
              </Text>
            </View>
          ))}
        </Swiper>
      );
    } else {
      return (
        <View
          style={{
            flex: 1,
          }}
        >
          {isLoading ? (
            <View
              style={{
                flex: 1,
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Text
                style={{
                  fontSize: 25,
                  color: COLORS.RED_PRIMARY,
                  fontFamily: FONTS.AvenirRegular,
                }}
              >
                {'LOADING ...'}
              </Text>
            </View>
          ) : (
            <View>
              <Image
                source={require('../../assets/home-page-banner.jpeg')}
                style={{
                  width: '100%',
                  height: 200,
                }}
              />
              <Text
                style={{
                  textTransform: 'uppercase',
                  fontFamily: FONTS.AvenirMedium,
                  fontSize: 20,
                  letterSpacing: 1,
                  color: COLORS.BLACK,
                  textAlign: 'center',
                  fontWeight: '700',
                  position: 'absolute',
                  left: 0,
                  right: 0,
                  top: 40,
                  textShadowColor: 'black',
                  textShadowOffset: { width: 1, height: 1 },
                  textShadowRadius: 25,
                }}
              >
                {'BOOK A CAMP AT HELPING\nHAND HOLIDAY CENTER'}
              </Text>
            </View>
          )}
        </View>
      );
    }
  }, [isLoading, sliders]);

  useEffect(() => {
    getSlider();
  }, [getSlider]);

  if (isDesktop()) {
    return (
      <ScrollView showsVerticalScrollIndicator={false}>
        <View>
          {isVolunteerIntructor ? (
            <Image
              source={require('../../assets/banner-home/intructor-volunteer-banner.jpeg')}
              style={{
                height: 550,
                width: '100%',
                resizeMode: 'cover',
              }}
            />
          ) : (
            <Image
              source={require('../../assets/home-page-banner.jpeg')}
              style={{
                height: 190,
                resizeMode: 'cover',
              }}
            />
          )}
        </View>
        <View
          style={{
            maxWidth: 1250,
            width: '90%',
            marginHorizontal: 'auto',
            marginTop: isVolunteerIntructor ? -450 : -140,
            zIndex: 2,
          }}
        >
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'flex-start',
              justifyContent: 'space-between',
            }}
          >
            <View style={{ width: '20%', minWidth: 230, marginRight: 20 }}>
              <User />
              <View
                style={{
                  height: 1,
                  backgroundColor: '#EBEBF0',
                  marginBottom: 20,
                }}
              ></View>
              {loggedin && <CorporateEvent />}
            </View>
            <View style={{ width: '75%' }}>
              {isVolunteerIntructor ? (
                <View
                  style={{
                    paddingTop: 390,
                    marginBottom: 25,
                  }}
                >
                  <View
                    style={[
                      {
                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                        shadowColor: '#F0F0F0',
                        shadowOffset: { width: 0, height: 12 },
                        shadowOpacity: 1,
                        shadowRadius: 32,
                        borderRadius: 18,
                        paddingVertical: 30,
                        marginBottom: 30,
                      },
                    ]}
                  >
                    <Text
                      style={{
                        fontFamily: FONTS.Arial,
                        fontWeight: '500',
                        fontSize: 30,
                        color: COLORS.BLACK,
                        letterSpacing: 1.5,
                        textAlign: 'center',
                        marginBottom: 5,
                        textTransform: 'uppercase',
                      }}
                    >
                      {`REGISTER AS AN ${user?.type_name} TO`}
                    </Text>
                    <Text
                      style={{
                        fontFamily: FONTS.Arial,
                        fontWeight: '700',
                        fontSize: 30,
                        color: COLORS.RED_PRIMARY,
                        letterSpacing: 1.5,
                        textAlign: 'center',
                      }}
                    >
                      UPCOMING ACTIVITIES
                    </Text>
                  </View>
                  <BookActivities />
                </View>
              ) : (
                <View>
                  <Text
                    style={{
                      textTransform: 'uppercase',
                      fontFamily: FONTS.AvenirMedium,
                      fontSize: 26,
                      letterSpacing: 2,
                      color: COLORS.BLACK,
                      textAlign: 'center',
                      marginBottom: 70,
                    }}
                  >
                    BOOK A CAMP AT HELPING HAND HOLIDAY CENTER
                  </Text>
                  <BookACamp />
                  <Notices />
                  <Activities />
                </View>
              )}
            </View>
          </View>
        </View>
        <Footer />
      </ScrollView>
    );
  }
  return (
    <>
      <ScrollView showsVerticalScrollIndicator={false}>
        {isVolunteerIntructor ? (
          <ImageBackground
            source={require('../../assets/banner-home/intructor-volunteer-banner-mobile.jpg')}
            style={{
              height: 200,
              width: '100%',
            }}
          >
            {IS_WEB ? (
              <View
                style={{
                  flex: 1,
                  alignItems: 'center',
                  paddingTop: 17,
                }}
              >
                <Text
                  style={{
                    fontFamily: FONTS.Arial,
                    fontWeight: '500',
                    fontSize: 18,
                    color: COLORS.BLACK,
                    letterSpacing: 1.5,
                    textAlign: 'center',
                    lineHeight: 20,
                  }}
                >
                  {'REGISTER AS AN\nINTRUCTOR TO'}
                </Text>
                <Text
                  style={{
                    fontFamily: FONTS.Arial,
                    fontWeight: '700',
                    fontSize: 18,
                    color: COLORS.RED_PRIMARY,
                    letterSpacing: 1.5,
                    textAlign: 'center',
                    lineHeight: 18,
                  }}
                >
                  UPCOMING ACTIVITIES
                </Text>
              </View>
            ) : (
              <View>
                {/* <LinearGradient
                colors={[
                  'rgba(255, 255, 255, 0)', // Transparent
                  'rgba(255, 255, 255, 0.5)', // 0.9 opacity white
                  '#FFFFFF', // Solid white
                ]}
                start={{ x: 0.5, y: 0.5 }}
                end={{ x: 0.5, y: 0 }}
                style={{
                  flex: 1,
                  alignItems: 'center',
                  paddingTop: 17,
                }}
              >
                <Text
                  style={{
                    fontFamily: FONTS.Arial,
                    fontWeight: '500',
                    fontSize: 18,
                    color: COLORS.BLACK,
                    letterSpacing: 1.5,
                    textAlign: 'center',
                    lineHeight: 20,
                  }}
                >
                  {'REGISTER AS AN\nINTRUCTOR TO'}
                </Text>
                <Text
                  style={{
                    fontFamily: FONTS.Arial,
                    fontWeight: '700',
                    fontSize: 18,
                    color: COLORS.RED_PRIMARY,
                    letterSpacing: 1.5,
                    textAlign: 'center',
                    lineHeight: 18,
                  }}
                >
                  UPCOMING ACTIVITIES
                </Text>
              </LinearGradient> */}
              </View>
            )}
          </ImageBackground>
        ) : (
          <View
            style={{
              position: 'relative',
              height: 200,
            }}
          >
            {renderSwiper}
          </View>
        )}

        <View
          style={[
            {
              paddingLeft: 20,
              paddingRight: 20,
              flexDirection: 'row',
            },
            isDesktop() && {
              maxWidth: MAX_WIDTH,
              width: '100%',
              alignSelf: 'center',
            },
          ]}
        >
          <View style={styles.container}>
            <User />
            {isIndividualCorporate && <Notices />}
          </View>
        </View>
        {isVolunteerIntructor ? (
          <View style={{ marginBottom: isDesktop() ? 30 : 0, zIndex: 2 }}>
            <BookActivities />
          </View>
        ) : (
          <View style={{ zIndex: 1 }}>
            <BookACamp />
            <Activities />
          </View>
        )}

        <Footer />
      </ScrollView>
    </>
  );
};

export default Home;
